/* Picasso Space deep links + cart handoff.
 *
 * Outbound — any element with [data-space-link]:
 *   data-artwork  (optional) product handle to seed the micro-app with
 *   data-source   attribution spot, e.g. "pdp:config", "artist:cta"
 *   On click we navigate to <base>/space/?artwork=…&source=…&return=<current page>.
 *   Base is https://picasso.arthaus.cloud, overridable for local dev via
 *   ?space_dev=1 (→ http://127.0.0.1:5174, persisted) / ?space_dev=0 (clear).
 *
 * Inbound — the micro-app hands back with ?arthaus_space_add=<handle> (now onto
 * the product page itself) and optionally &arthaus_space_variant=<id> when the
 * shopper picked a print size in Space:
 *   fetch the product, add the requested variant (validated, else first
 *   available), clean the URL, and open the cart drawer
 *   (ArthausCart.openWithItem) or fall back to /cart.
 */
(function () {
  'use strict';

  var PROD_BASE = 'https://picasso.arthaus.cloud';
  var DEV_BASE = 'http://127.0.0.1:5174';
  var BASE_KEY = 'arthaus_space_base';

  function storage(fn, fallback) {
    try { return fn(); } catch (e) { return fallback; }
  }

  // ── Dev toggle: ?space_dev=1 points space links at the local Vite runner ──
  var params = new URLSearchParams(window.location.search);
  if (params.has('space_dev')) {
    if (params.get('space_dev') === '0') {
      storage(function () { localStorage.removeItem(BASE_KEY); });
    } else {
      storage(function () { localStorage.setItem(BASE_KEY, DEV_BASE); });
    }
  }

  function spaceBase() {
    return storage(function () { return localStorage.getItem(BASE_KEY); }) || PROD_BASE;
  }

  function spaceUrl(artwork, source, artworks) {
    var ret = new URL(window.location.href);
    ret.searchParams.delete('arthaus_space_add');
    ret.searchParams.delete('arthaus_space_variant');
    ret.searchParams.delete('space_dev');
    var url = spaceBase() + '/space/?';
    var qs = new URLSearchParams();
    // For a set: seed `artwork` with the lead piece (works with the live single-art
    // flow today) AND pass `artworks` (all handles) for the forthcoming 3-up gallery
    // wall endpoint — the current app reads `artwork` and ignores `artworks`.
    if (artworks) { qs.set('artworks', artworks); if (!artwork) artwork = artworks.split(',')[0]; }
    if (artwork) qs.set('artwork', artwork);
    qs.set('source', source || 'marketplace');
    qs.set('return', ret.toString());
    return url + qs.toString();
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-space-link]');
    if (!link) return;
    e.preventDefault();
    window.location.href = spaceUrl(link.getAttribute('data-artwork'), link.getAttribute('data-source'), link.getAttribute('data-artworks'));
  });

  // ── Inbound cart handoff ──────────────────────────────────────────────────
  var handle = params.get('arthaus_space_add');
  if (!handle) return;
  var requestedVariant = parseInt(params.get('arthaus_space_variant'), 10) || null;

  // Clean the params immediately so refresh/back doesn't re-add.
  var clean = new URL(window.location.href);
  clean.searchParams.delete('arthaus_space_add');
  clean.searchParams.delete('arthaus_space_variant');
  window.history.replaceState({}, '', clean.toString());

  fetch('/products/' + encodeURIComponent(handle) + '.js')
    .then(function (r) { if (!r.ok) throw new Error('product ' + r.status); return r.json(); })
    .then(function (product) {
      var variants = product.variants || [];
      // Prefer the size the shopper picked in Space (validated + in stock).
      var variant = requestedVariant && variants.filter(function (v) {
        return v.id === requestedVariant && v.available;
      })[0];
      variant = variant
        || variants.filter(function (v) { return v.available; })[0]
        || variants[0];
      if (!variant) throw new Error('no variant');
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variant.id, quantity: 1 })
      });
    })
    .then(function (r) { if (!r.ok) throw new Error('add ' + r.status); return r.json(); })
    .then(function () {
      document.dispatchEvent(new CustomEvent('cart:updated'));
      if (window.ArthausCart && typeof window.ArthausCart.openWithItem === 'function') {
        window.ArthausCart.openWithItem();
      } else {
        window.location.href = '/cart';
      }
    })
    .catch(function (err) {
      // Hand the shopper to the PDP instead of failing silently.
      console.warn('[space] cart handoff failed', err);
      window.location.href = '/products/' + encodeURIComponent(handle);
    });
})();
